export default {
  "1": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Seleccionar tienda"])},
  "2": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Sin título"])}
}